import type { ShallowRef } from 'vue';
import type { GrowthBook } from '@growthbook/growthbook';

export const FEATURE_FLAG_TOKEN = Symbol('tundr-feature-flags');

/**
 * Module-level ref set by FeatureFlagPlugin.
 * Needed by featureFlagGuard which runs outside Vue's injection context.
 */
export let growthBookRef: ShallowRef<GrowthBook> | null = null;

/**
 * Promise that resolves when GrowthBook init completes (or fails).
 * Used by featureFlagGuard to wait for flags to be loaded before evaluating.
 */
export let growthBookInitPromise: Promise<unknown> | null = null;

export function setGrowthBookRef(ref: ShallowRef<GrowthBook>): void {
  growthBookRef = ref;
}

export function setGrowthBookInitPromise(promise: Promise<unknown>): void {
  growthBookInitPromise = promise;
}
